import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import { PREQUAL_COLORS } from "../constants";

// Decorative "success" mark from the result designs (Figma 36146-427987):
// 124px gold ring, 106px teal check circle, sparkle accents. Purely visual.
export const PrequalCheckCircle = () => (
  <span
    aria-hidden="true"
    className="relative mt-6 flex h-[124px] w-[124px] items-center justify-center"
  >
    <span
      className="absolute inset-0 rounded-full border-2"
      style={{ borderColor: PREQUAL_COLORS.goldRing }}
    />
    <span
      className="flex h-[106px] w-[106px] items-center justify-center rounded-full"
      style={{ backgroundColor: PREQUAL_COLORS.teal }}
    >
      <CheckIcon sx={{ fontSize: 44, color: "#FFFFFF" }} />
    </span>
    <img
      src="/assets/icons/plan-savings-sparkle.svg"
      alt=""
      className="absolute -right-2 top-0 h-4 w-4"
    />
    <img
      src="/assets/icons/plan-savings-sparkle.svg"
      alt=""
      className="absolute -left-3 bottom-3 h-3 w-3"
    />
    <span
      className="absolute right-[-22px] top-6 h-2.5 w-2.5 rounded-full"
      style={{ backgroundColor: PREQUAL_COLORS.gold }}
    />
    <span
      className="absolute -bottom-2 left-1 h-1.5 w-1.5 rounded-full"
      style={{ backgroundColor: PREQUAL_COLORS.gold }}
    />
  </span>
);
